import { render, staticRenderFns } from "./director-turma-search.vue?vue&type=template&id=0d9bac26&"
import script from "./director-turma-search.vue?vue&type=script&lang=js&"
export * from "./director-turma-search.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports